import { render, staticRenderFns } from "./wechatNav.vue?vue&type=template&id=66d466c6&scoped=true&"
import script from "./wechatNav.vue?vue&type=script&lang=js&"
export * from "./wechatNav.vue?vue&type=script&lang=js&"
import style0 from "./wechatNav.vue?vue&type=style&index=0&id=66d466c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d466c6",
  null
  
)

export default component.exports